import {
  EValue,
  IPromoTypeTermsFieldSchema,
} from '../../repositories/newbuilding-promos/entities/json_query/PromoTypeTermsFieldSchema';
import { EPromoType, IJsonQueryPromoType } from '../../types/jsonQuery/promoType';
import { EJsonQueryType } from '../../types/jsonQuery/term';

const PROMO_TYPE_MAP = new Map([
  [EValue.Bonus, EPromoType.Bonus],
  [EValue.CianMortgage, EPromoType.CianMortgage],
  [EValue.Discount, EPromoType.Discount],
  [EValue.MaternalCapital, EPromoType.MaternalCapital],
  [EValue.Military, EPromoType.Military],
  [EValue.Mortgage, EPromoType.Mortgage],
]);

export function mapPromoType(term?: IPromoTypeTermsFieldSchema | null): IJsonQueryPromoType | null {
  if (!term) {
    return null;
  }

  return {
    type: EJsonQueryType.Terms,
    value: term.value.map(item => PROMO_TYPE_MAP.get(item) as EPromoType),
  };
}
